<template>
    <div class="mobile-menu-modal-mask">
        <div class="mobile-menu-modal-container d-flex flex-column justify-content-center align-items-center">
            <button class="close-button" @click="closeModal()">
                <i class="fal fa-times"></i>
            </button>

            <ul>
                <!-- primary -->
                <template v-if="hasPrimaryMenu">
                    <li v-for="(menuItem, index) in primaryMenu" :key="index" class="nav-list__item">
                        <a class="nav-list__link" :href="menuItem.url"> {{ menuItem.name }}</a>
                    </li>
                </template>

                <!-- CTA -->
                <template v-if="hasMainNavigationCTA">
                    <li class="nav-list__item">
                        <div class="nav-btn">
                            <a class="btn btn--secondary btn--small js-event-tracker" href="/" data-event="NavApply">
                                <span class="nav-list__btn-text">{{ $t('genaral.main_navigation_cta_text') }}</span>
                                <span class="nav-list__icon icon icon-angle-right" aria-hidden="true"></span>
                            </a>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()
        return {
            store,
        }
    },
    data() {},
    methods: {
        closeModal: function () {
            this.emitter.emit('close-menu')
        },
    },
    computed: {
        menu: function () {
            return this.store.state.global.data.menu || {}
        },
        primaryMenu: function () {
            return this.menu.primary || false
        },
        hasMainNavigationCTA: function () {
            return parseInt(this.themeSetting('main_navigation_cta')) === 0
        },
        hasPrimaryMenu: function () {
            return this.primaryMenu.length
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/variables';

.mobile-menu-modal-mask {
    background-color: var(--white);
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    transition: opacity 0.3s ease;
    width: 100%;
    z-index: 9998;
}

.btn.btn--secondary.btn--small.js-event-tracker {
    border: 1px solid var(--primary);
}

.mobile-menu-modal-container {
    background-color: var(--nav-overwrite);
    height: 100%;
    position: relative;

    .close-button {
        background-color: transparent;
        border: none;
        font-size: rem(24px);
        position: absolute;
        right: 16px;
        top: 16px;
    }

    ul {
        text-align: center;

        & > * + * {
            margin-top: 40px;
        }

        li {
            a {
                color: var(--nav-text);
                font-size: rem(22px);
                font-weight: 700;

                &.button {
                    &.bordered {
                        border: 1px solid var(--nav-text);
                        color: var(--nav-text);
                        max-width: calc(100% - 32px);
                        white-space: normal;
                    }
                }
            }
        }
    }
}
</style>
